// extracted by mini-css-extract-plugin
module.exports = {"link":"Banner_link__1MiyF"};